import React from "react";

const AmountModeField = ({
  className = "",
  disabled = false,
  id,
  inputClassName = "form-control",
  min,
  mode = "%",
  name,
  onChange,
  onFocus,
  onKeyPress,
  onModeToggle,
  placeholder = "Enter",
  readOnly = false,
  step,
  type = "number",
  value,
}) => (
  <div className={`amount-mode-field ${className}`.trim()}>
    <button
      type="button"
      className="amount-mode-toggle"
      onClick={onModeToggle}
      disabled={disabled}
      aria-label={`Switch amount mode. Current mode ${mode}`}
    >
      {mode}
    </button>
    <input
      autoComplete="off"
      className={inputClassName}
      disabled={disabled}
      id={id}
      min={min}
      name={name}
      onChange={onChange}
      onFocus={onFocus}
      onKeyPress={onKeyPress}
      placeholder={placeholder}
      readOnly={readOnly}
      step={step}
      style={{ textAlign: "right" }}
      type={type}
      value={value}
    />
  </div>
);

export default React.memo(AmountModeField);
